import { gql } from '@apollo/client';
import { CodeableConceptFragment } from 'fhir/general/CodeableConcept';

export const GetAdmissionConsentPDFS = gql`
  query GetAdmissionConsentPDFS(
    $patientId: String!
    $encounterId: String!
    $documentTypes: [String]!
  ) {
    GetAdmissionConsentPDFS(
      patientId: $patientId
      encounterId: $encounterId
      documentTypes: $documentTypes
    ) {
      admissionConsentPdfs {
        type {
          coding {
            code
          }
        }
        content {
          attachment {
            id
            title
          }
        }
      }
    }
  }
`;

export const createUpdateAdmissionConsentProvenance = gql`
  mutation createUpdateAdmissionConsentProvenance(
    $provenanceDetails: AdmissionConsentProvenanceInput
    $patientId: String!
    $encounterId: String!
  ) {
    createUpdateAdmissionConsentProvenance(
      provenanceDetails: $provenanceDetails
      patientId: $patientId
      encounterId: $encounterId
    ) {
      id
    }
  }
`;

export const GetProvenanceByAgentTypeQuery = gql`
  query GetProvenanceByAgentType($patientId: String!, $encounterId: String! ) {
    GetProvenanceByAgentType(patientId: $patientId, encounterId: $encounterId) {
      id
      extension {
        url
        valueBoolean
        valueString
      }
      contained {
        position {
          latitude
          longitude
          altitude
        }
      }
      resourceType
      recorded
      reason {
        ...CodeableConcept
      }
      agent {
        who {
          identifier {
            value
          }
          display
        }
      }
      target {
        reference
      }
      activity {
        coding {
          code
          display
          system
        }
      }
      previousEncounterProvenance {
        id
        extension {
          url
          valueBoolean
          valueString
        }
        recorded
        reason {
          ...CodeableConcept
        }
        agent {
          who {
            identifier {
              value
            }
            display
          }
        }
        activity {
          coding {
            code
            display
            system
          }
        }
      }
    }
  }
  ${CodeableConceptFragment}
`;
